<template>
  <div class="w-full mt-44 lg:mt-60">
    <h2 class="text-center py-18 text-28 mb-28 lg:mb-34 lg:text-32">
      THE GALLERY
    </h2>

    <loading v-if="loading" class="mx-auto"></loading>

    <div v-else>
      <three-column-grid v-if="this.$mq.lg" :artworks="artworks">
        <template v-slot:default="{ artwork }">
          <artwork-card
            class="mb-30 lg:mb-56"
            :artwork="artwork"
            @update:artwork="sync(artwork, $event)">
          </artwork-card>
        </template>
      </three-column-grid>

      <two-column-grid v-else-if="this.$mq.md" :artworks="artworks">
        <template v-slot:default="{ artwork }">
          <artwork-card
            class="mb-30 lg:mb-56"
            :artwork="artwork"
            @update:artwork="sync(artwork, $event)">
          </artwork-card>
        </template>
      </two-column-grid>

      <div v-else class="px-18">
        <artwork-card
          v-for="(artwork, index) in artworks"
          :key="index"
          :artwork="artwork"
          class="mb-30 lg:mb-56"
          @update:artwork="sync(artwork, $event)">
        </artwork-card>
      </div>
    </div>
  </div>
</template>
<script>
import ThreeColumnGrid from "../../Universal/GridLoader/ThreeColumnGrid.vue";
import TwoColumnGrid from "../../Universal/GridLoader/TwoColumnGrid.vue";
import ArtworkCard from "../../Universal/GridLoader/Cards/ArtworkCard.vue";

export default {
  components: {
    ThreeColumnGrid,
    TwoColumnGrid,
    ArtworkCard,
  },

  data () {
    return {
      artworks: [],
      loading: true,
    }
  },

  methods: {
    sync (target, source) {
      Object.assign(target, source)
    },
  },

  props: {
    event: { required: true, type: Object },
  },

  created() {
    axios.get(`/web/api/exhibitions/${this.event.slug}/artworks`)
      .then(({ data }) => {
        this.artworks = data.data
        this.loading = false
      })
  },
}
</script>
